import React from 'react';
import { SearchMetaWrapper as SearchMetaWrapperComponent } from '@jetshop/ui/Search/SearchPage/SearchMeta';
import t from '@jetshop/intl';
import styled from 'react-emotion';

const Matches = styled('div')`
  span {
    padding-right: 0.5rem;
  }
`;

const PageOf = styled('div')`
  align-self: flex-end;
  margin-top: 1rem;
`;

const SearchMetaWrapper = styled(SearchMetaWrapperComponent)`
  color: ${({ theme }) => theme.colors.black};
  flex-wrap: wrap;
  justify-content: center;
  padding: 0;
`;

const Wrapper = styled('div')`
  width: 100%;
`;

const Headline = styled('h2')`
  display: block;
  font-size: 1.5rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.font};
  margin-bottom: 1.5rem;
`;
const SearchMeta = ({ total, page, pages, term }) => (
  <SearchMetaWrapper>
    <Wrapper>
      <Headline>{t('Search result')}</Headline>
      <Matches>
        {t('{total, plural, =1 {# item} other {# items}}', {
          total,
          term
        })}
      </Matches>
    </Wrapper>
    <PageOf>{t('Page {page} of {pages}', { page, pages })}</PageOf>
  </SearchMetaWrapper>
);

export default SearchMeta;
